import React, { Component } from "react";
import { GET, format_date, loading, t } from "../../../components/CustomComponent.js";
import { typeMeta, initials, avatarTone, fmtPhone } from "../../../components/people_option.js";
import ICON from "../icons.js";

/* ============================================================================
 * HomeProfileModal — โปรไฟล์ของฉัน บนหน้าเว็บสาธารณะ
 *
 * พาร์ตเนอร์ที่ล็อกอินแล้วอยู่ที่เว็บสาธารณะ เข้าหลังบ้านไม่ได้ (บทบาทไม่มีสิทธิ์เมนูใด)
 * กล่องนี้จึงเป็นที่เดียวที่เห็นได้ว่า "ระบบเก็บข้อมูลอะไรของเราไว้บ้าง"
 *
 * แสดงอย่างเดียว ไม่มีการแก้ไข — ข้อมูลพาร์ตเนอร์ทั้งชุดผูกกับใบสมัครที่ผ่านการ
 * ตรวจเอกสารและยืนยันตัวตนมาแล้ว การให้แก้เองทีหลังจะทำให้สิ่งที่ทีมงานอนุมัติไว้
 * กับสิ่งที่อยู่ในระบบไม่ตรงกัน (ด้วยเหตุผลเดียวกับที่อีเมลแก้ไม่ได้ทั้งสองฝั่ง)
 * ต้องแก้จริงให้ติดต่อทีมงาน ส่วนรหัสผ่านตั้งใหม่ได้ที่หน้า "ลืมรหัสผ่าน"
 *
 * ใช้ปลายทางเดิมของระบบ ไม่ได้ทำ API ใหม่ :
 *   GET admin/users/profile   ดึงค่าปัจจุบัน (ไม่ต้องมี permission ใด)
 * ========================================================================== */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeProfileModal extends Component {
  state = {
    data: null,
    loaded: false,
  };

  componentDidMount() {
    window.addEventListener("keydown", this.onKey);
    if (this.props.open) this.Load();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      document.body.classList.add("hm-lg-noscroll"); // กันหน้าเว็บด้านหลังเลื่อนตาม
      this.Load();
    }
    if (prevProps.open && !this.props.open) document.body.classList.remove("hm-lg-noscroll");
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKey);
    document.body.classList.remove("hm-lg-noscroll");
  }

  onKey = (event) => {
    if (this.props.open && event.key === "Escape") this.props.onClose();
  };

  /* ดึงค่าสดจาก API ทุกครั้งที่เปิด ไม่ใช้ของใน localStorage — ค่าในเครื่องถูกเขียน
     ตอนล็อกอินและไม่ได้อัปเดตอีกเลย ถ้าผู้ดูแลแก้ข้อมูลให้ทีหลังจะยังโชว์ของเก่า
     ไม่ขึ้นโครงหน้าไว้ก่อนแล้วค่อยเติมค่า เพราะโครงเปล่า ๆ ที่มีแต่ขีดกลางเต็มไปหมด
     ดูเหมือนบัญชีไม่มีข้อมูลมากกว่าดูเหมือนกำลังโหลด */
  Load = async () => {
    this.setState({ loaded: false, data: null });

    loading(true);
    const result = await GET("admin/users/profile");
    loading(false);

    if (result?.status !== true) return this.props.onClose();

    this.setState({ loaded: true, data: result.data || {} });
  };

  /* หนึ่งบรรทัดข้อมูล : ไอคอน + ป้ายชื่อ + ค่า — ค่าที่ยังไม่ได้กรอกโชว์ขีดกลางจาง ๆ
     ไม่ซ่อนทั้งบรรทัดทิ้ง เพื่อให้เห็นว่า "ช่องนี้มีอยู่แต่ยังว่าง"
     tone ใส่เฉพาะบรรทัดที่ค่าเป็นผลลัพธ์ (ยืนยันแล้ว / ยังไม่ยืนยัน) ให้มีจุดสีนำหน้า */
  row = (icon, label, value, tone) => (
    <div className="hm-pf__row">
      <span className="hm-pf__row-icon hm-ico">{icon}</span>
      <span className="hm-pf__row-label">{label}</span>
      <span className={`hm-pf__row-value ${value ? "" : "is-empty"} ${tone ? `is-${tone}` : ""}`}>
        {value || "-"}
      </span>
    </div>
  );

  renderBody = () => {
    const data = this.state.data || {};
    const type = typeMeta(data.user_type);
    const name = data.full_name || data.email || "-";

    return (
      <>
        {/* หัวกล่อง : แถบเข้มเต็มความกว้าง ใช้ลายเซ็นเดียวกับแผงแบรนด์ของกล่องเข้าสู่ระบบ
            รูปโปรไฟล์ไม่มีก็ใช้อักษรย่อบนพื้นไล่เฉดที่คงที่ต่อคน (ไม่สุ่มใหม่ทุกครั้ง) */}
        <div className="hm-pf__hero">
          <span className="hm-pf__hero-wedge" />

          <div className="hm-pf__avatar" style={{ background: avatarTone(data.uid || name) }}>
            {data.picture ? <img src={data.picture} alt={name} /> : initials(name)}
          </div>

          <div className="hm-pf__ident">
            <h2 className="hm-pf__name" id="hm-pf-title">
              {name}
              {!!data.nickname && <em>({data.nickname})</em>}
            </h2>
            <div className="hm-pf__tags">
              <span className="hm-pf__tag hm-pf__tag--lime">{t(type.label)}</span>
              <span className={`hm-pf__tag ${data.is_active ? "is-on" : "is-off"}`}>
                {t(data.is_active ? "active" : "inactive")}
              </span>
              {!!data.user_code && <span className="hm-pf__tag hm-pf__tag--code">{data.user_code}</span>}
            </div>
          </div>
        </div>

        <div className="hm-pf__body">
          <section className="hm-pf__section">
            <div className="hm-pf__section-title">{t("contact")}</div>
            {this.row(ICON.mail, t("email"), data.email)}
            {this.row(ICON.phone, t("phone"), data.phone ? fmtPhone(data.phone) : "")}
            {this.row(ICON.comment, t("line_id"), data.line_id)}
          </section>

          <section className="hm-pf__section">
            <div className="hm-pf__section-title">{t("partner_profile_account")}</div>
            {/* บทบาทกับทีม/สาขาเป็นศัพท์ของหลังบ้าน (พาร์ตเนอร์ได้บทบาทเดียวกันหมดและไม่ได้สังกัดสาขา)
                ตรงนี้จึงบอกผลการยืนยันตัวตนแทน — เป็นสิ่งเดียวในหมวดนี้ที่มีผลกับตัวเจ้าของบัญชีจริง */}
            {this.row(
              ICON.shield,
              t("partner_profile_verify"),
              t(data.is_verify ? "partner_profile_verified" : "partner_profile_unverified"),
              data.is_verify ? "on" : "off"
            )}
            {this.row(
              ICON.clock,
              t("last_login"),
              data.last_login_at ? format_date(data.last_login_at, "dd mmm yyyy hh:mm", locale()) : t("time_never")
            )}
            {this.row(
              ICON.calendar,
              t("created_at"),
              data.created_at ? format_date(data.created_at, "dd mmm yyyy", locale()) : ""
            )}
          </section>

          {/* ต้องบอกไว้ว่าทำไมถึงไม่มีปุ่มแก้ไข ไม่งั้นคนที่เข้ามาหวังจะแก้เบอร์โทรจะคิดว่าระบบพัง */}
          <p className="hm-pf__note">
            <span className="hm-ico">{ICON.info}</span>
            {t("partner_profile_view_note")}
          </p>
        </div>
      </>
    );
  };

  render() {
    const { open, onClose } = this.props;
    const { loaded } = this.state;

    if (!open) return null;

    return (
      <div className="hm-lg" role="dialog" aria-modal="true" aria-labelledby="hm-pf-title">
        <button type="button" className="hm-lg__scrim" aria-label={t("cancel")} onClick={onClose} />

        <div className="hm-lg__box hm-lg__box--single hm-lg__box--profile">
          <button type="button" className="hm-lg__close" aria-label={t("cancel")} onClick={onClose}>
            <span className="hm-ico">{ICON.close}</span>
          </button>

          <div className="hm-lg__panel">
            {loaded ? this.renderBody() : <div className="hm-pf__wait" />}

            <div className="hm-lg__foot hm-pf__foot">
              <button type="button" className="hm-btn hm-btn--ghost" onClick={onClose}>
                {t("close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
